export const DERATIZACIJA_V1_ResourcesEN: DERATIZACIJA_V1_ResourcesBSInterface =
  {
    labelDone: "Task completion date",
    errors: {
      registerPic: "The picture you are uploading is too large.",
      recordAlreadyExists:
        "This evidence has already been filled out. You cannot fill it out again.",
    },
    evidencijaForm: {
      buttonForward: "Sign",
      buttonBack: "Back",
    },
    successModal: {
      title: "Data Entry",
      body: "Data addition has been successfully completed. Select OK to continue.",
      buttonOk: "OK",
    },
    txtPotvrda:
      "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
    profilePicture: {
      label: "Images",
      name: "profilePicture",
      error: "Please select your profile picture",
      validation: "Wrong profile picture",
      description: () => (
        <>
          <h4>Drop files here or click to upload.</h4>
          <span className="text-muted font-13">Only images, max 6MB</span>
        </>
      ),
    },
    errorMissingInput: "Please fill in all fields",
    kontrola: {
      checkboxLabel: "Rodent infestation",
      opisKontrole: "Control description",
      errorOpisKontrole: "Control description entry is required",
    },
    korekcija: {
      stanjeKorekcije: "Correction status",
      opisKorekcije: "Correction description",
    },
  };

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface ProfilePicture {
  label: string;
  name: string;
  error: string;
  validation: string;
  description: () => JSX.Element;
}

interface Kontrola {
  checkboxLabel: string;
  opisKontrole: string;
  errorOpisKontrole: string;
}

interface Korekcija {
  stanjeKorekcije: string;
  opisKorekcije: string;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface DERATIZACIJA_V1_ResourcesBSInterface {
  labelDone: string;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  profilePicture: ProfilePicture;
  errorMissingInput: string;
  kontrola: Kontrola;
  korekcija: Korekcija;
  errors: IErrors;
}
